import {Action, getModule, Module, Mutation, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/model/store/store';
import api from '@/model/api';
import {GCIAboutRes, GCIAboutInfoRes} from '@/model/dto/res/about/get-about-info-res';
import {PUADataReq, PostUpsertAboutReq} from '@/model/dto/req/about/post-upsert-about-req';
import {PUIADataReq, PostUploadImageAboutReq} from '@/model/dto/req/about/post-upload-image-about-req';
import {PostUploadImageAboutRes, PostUploadImageAboutInfoRes} from '@/model/dto/res/about/post-upload-image-about-res';

@Module({dynamic: true, store, namespaced: true, name: 'AboutModule'})
class AboutModule extends VuexModule {

  public about: string = ''; // ID
  public aboutInfo: GCIAboutRes = {
    id: 0,
    title: '',
    text: '',
    status: 0,
    deleted: false
  };
  public upsertStatus: number = 0;
  public uploadImageInfo: PostUploadImageAboutRes = {
    status: 0,
    message: '',
    path: ''
  };

  // Mutations
  @Mutation
  private setAbout(about: GCIAboutRes): void {
    this.aboutInfo = about;
  }

  @Mutation
  private setAboutTitle(str: string): void {
    this.aboutInfo.title = str;
  }

  @Mutation
  private setAboutText(str: string): void {
    this.aboutInfo.text = str;
  }

  // Actions
  /**
   * コンテンツの初期化
   *
   * @param param
   */
   @Action({ rawError: true })
   public pushAboutTitle(
     str: string
   ): void {
     this.setAboutTitle(str);
   }

   @Action({ rawError: true })
   public pushAboutText(
     str: string
   ): void {
     this.setAboutText(str);
   }

  /**
   * コンテンツ情報をリクエスト
   *
   * TODO:
   */
  @MutationAction({ rawError: true })
  public async requestAboutInfo(id: number): Promise<any> {
    try {
      const info = await api.getAboutInfo(id);
      return {
        aboutInfo: info.results
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * メモ情報追加をリクエスト
   */
  @MutationAction({ rawError: true })
  public async requestUpsertAboutInfo(
    param: PUADataReq
  ): Promise<any> {
    try {
      const data = await api.postUpsertAboutInfo(param);
      let status: number = data?.results.status ?? 0;
      if (status === 0) { status = Math.floor( Math.random() * 101 ); }
      return {
        upsertStatus: status
      };
    } catch (err) {
      throw err;
    }
  }

  /**
   * コンテンツ内の画像アップロードをリクエスト
   */
  @MutationAction({ rawError: true })
  public async requestUploadImageAboutInfo(
    param: {
      file: File,
      id: string
    }
  ): Promise<any> {
    try {
      const res = await api.postUploadImageAboutInfo(param);
      return {
        uploadImageInfo: res.results
      };
    } catch (err) {
      throw err;
    }
  }

}

export default getModule(AboutModule, store);
